import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-body d-flex flex-column p-3" }
const _hoisted_2 = { class: "d-flex flex-column flex-grow-1" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  class: "fw-bolder fs-5",
  style: {"color":"#008ffb"}
}, "Ethoca / Verifi", -1)
const _hoisted_4 = { class: "mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"]),
    style: `background-color: #ffffff`
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_apexchart, {
            class: "mixed-widget-13-chart",
            options: _ctx.chartOptionsSpark2,
            series: _ctx.series,
            height: _ctx.chartHeight,
            type: "area"
          }, null, 8, ["options", "series", "height"])
        ])
      ])
    ])
  ], 2))
}